module.exports = __webpack_public_path__ + "static/media/VM Copy.f89ff957.png";